import React, { useEffect, useState } from "react";

// import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

import { Spin, message, Select, Tooltip, Table, Checkbox } from "antd";

import dayjs from "dayjs";

import axios from "axios";

import PropTypes from "prop-types";

import Search from "antd/es/input/Search";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import TaskDetailDrawer from "../Tasks/TaskDetailDrawer";
import NewTask from "../Tasks/NewTask";
import { BASE_CRM_URL } from "../../../components/config/config";

const ProjectTasks = ({ CustomerData }) => {
  console.log(CustomerData, "customerData");
  const customerId = CustomerData?.id;
  console.log(customerId, "customeriddddddddddddddd");
  // const route = all_routes;

  const [taskStatusOptions, setTaskStatusOptions] = useState([]);
  const [statusOptionsLoading, setStatusOptionsLoading] = useState(false);
  const [updatingStatusTaskId, setUpdatingStatusTaskId] = useState(null);

  const [priorityOptions, setPriorityOptions] = useState([]);
  const [priorityOptionsLoading, setPriorityOptionsLoading] = useState(false);
  const [updatingPriorityTaskId, setUpdatingPriorityTaskId] = useState(null);

  // const normalizeText = (value) =>
  //   String(value || "")
  //     .toLowerCase()
  //     .replace(/[\s-]/g, "");

  // const getPriorityColorKey = (priorityName) => {
  //   switch (normalizeText(priorityName)) {
  //     case "low":
  //       return "success";

  //     case "medium":
  //       return "primary";

  //     case "high":
  //       return "warning";

  //     case "urgent":
  //       return "danger";

  //     default:
  //       return "secondary";
  //   }
  // };

  // const getPriorityOptionById = (priorityId) =>
  //   priorityOptions.find(
  //     (option) => Number(option.priorityid) === Number(priorityId),
  //   );

  const fetchTaskStatuses = async () => {
    try {
      setStatusOptionsLoading(true);

      const response = await fetch(`${BASE_CRM_URL}tasks/GetTaskStatus`);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      console.log("STATUS API:", result);

      setTaskStatusOptions(
        Array.isArray(result?.ResultData) ? result.ResultData : [],
      );
    } catch (error) {
      console.error("Error fetching task statuses:", error);
      setTaskStatusOptions([]);
    } finally {
      setStatusOptionsLoading(false);
    }
  };

  const fetchPriorities = async () => {
    try {
      setPriorityOptionsLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetPriorities`);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      console.log("PRIORITY API:", result);

      setPriorityOptions(
        Array.isArray(result?.ResultData) ? result.ResultData : [],
      );
    } catch (error) {
      console.error("Error fetching priorities:", error);
      setPriorityOptions([]);
    } finally {
      setPriorityOptionsLoading(false);
    }
  };

  useEffect(() => {
    fetchTaskStatuses();
    fetchPriorities();
  }, []);

  const avatarColors = [
    { background: "#E7F1FF", color: "#0D6EFD" },
    { background: "#E8F8F0", color: "#198754" },
    { background: "#FFF4DE", color: "#FF9800" },
    { background: "#FDECEC", color: "#DC3545" },
    { background: "#E8F7FA", color: "#0DCAF0" },
    { background: "#F3E8FF", color: "#6F42C1" },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
      render: (text, record) => (
        <Tooltip title={text}>
          <span
            onClick={(event) => {
              event.preventDefault();
              openTaskDetail("view", record);
            }}
          >
            {text?.length > 45 ? `${text.substring(0, 45)}...` : text || "N/A"}
          </span>
        </Tooltip>
      ),
    },

    // {
    //   title: "Status",
    //   dataIndex: "status",

    //   render: (status, record) => {
    //     const isUpdating = updatingStatusTaskId === record.id;

    //     const statusSelectOptions = taskStatusOptions.map((option) => ({
    //       value: option.Id,
    //       label: option.Status,
    //     }));

    //     return (
    //       <Select
    //         value={record.statusId}
    //         options={statusSelectOptions}
    //         placeholder={status || "Select Status"}
    //         style={{ minWidth: 100 }}
    //         size="small"
    //         loading={statusOptionsLoading || isUpdating}
    //         disabled={statusOptionsLoading || isUpdating}
    //         onChange={(newStatusId) => {
    //           updateTaskStatus(record.id, newStatusId);
    //         }}
    //       />
    //     );
    //   },
    // },

    {
      title: "Status",
      dataIndex: "status",

      render: (status, record) => {
        const isUpdating = updatingStatusTaskId === record.id;

        const getStatusColor = (statusName) => {
          switch (
            String(statusName || "")
              .toLowerCase()
              .replace(/\s+/g, "")
          ) {
            case "complete":
            case "completed":
              return "#198754";

            case "testing":
              return "#0d6efd";

            case "inprogress":
              return "#ffc107";

            case "notstarted":
              return "#dc3545";

            case "awaitingfeedback":
              return "#0dcaf0";

            default:
              return "#6c757d";
          }
        };

        const statusSelectOptions = taskStatusOptions.map((option) => ({
          value: option.Id,
          label: option.Status,
        }));

        const selectedStatus = taskStatusOptions.find(
          (option) => Number(option.Id) === Number(record.statusId),
        );

        const statusColor = getStatusColor(selectedStatus?.Status || status);

        return (
          <Select
            value={selectedStatus ? record.statusId : undefined}
            size="small"
            loading={statusOptionsLoading || isUpdating}
            disabled={statusOptionsLoading || isUpdating}
            style={{
              width: 125,
            }}
            styles={{
              selector: {
                border: `1px solid ${statusColor}`,
                borderRadius: "6px",
              },
            }}
            dropdownStyle={{
              zIndex: 9999,
            }}
            options={statusSelectOptions}
            onChange={(newStatusId) => {
              if (Number(newStatusId) === Number(record.statusId)) {
                return;
              }

              updateTaskStatus(record.id, newStatusId);
            }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getStatusColor(option.data.label),
                    fontSize: "9px",
                  }}
                />

                <span>{option.data.label}</span>
              </div>
            )}
            labelRender={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: statusColor,
                    fontSize: "9px",
                  }}
                />

                <span>
                  {selectedStatus?.Status || status || "Select Status"}
                </span>
              </div>
            )}
          />
        );
      },
    },

    {
      title: "Start Date",
      dataIndex: "startdate",
      sorter: (a, b) => new Date(a.startdate) - new Date(b.startdate),
      render: (date) => (
        <span>{date ? dayjs(date).format("DD-MM-YYYY") : "N/A"}</span>
      ),
    },

    {
      title: "Due Date",
      dataIndex: "duedate",
      sorter: (a, b) => new Date(a.duedate) - new Date(b.duedate),
      render: (date) => (
        <span>{date ? dayjs(date).format("DD-MM-YYYY") : "N/A"}</span>
      ),
    },

    {
      title: "Assigned To",
      dataIndex: "staff_names",

      render: (assignedTo) => {
        const staffNames = assignedTo
          ? String(assignedTo)
              .split(",")
              .map((name) => name.trim())
              .filter(Boolean)
          : [];

        return (
          <div className="avatar-list-stacked d-flex">
            {staffNames.length > 0 ? (
              staffNames.map((name, index) => {
                const color = avatarColors[index % avatarColors.length];

                return (
                  <span
                    key={`${name}-${index}`}
                    className="avatar avatar-rounded fw-bold d-flex justify-content-center align-items-center"
                    style={{
                      width: 35,
                      height: 35,
                      fontSize: 14,
                      backgroundColor: color.background,
                      color: color.color,
                      borderRadius: "50%",
                      marginRight: "-8px",
                      border: "2px solid #fff",
                    }}
                    title={name}
                  >
                    {name.charAt(0).toUpperCase()}
                  </span>
                );
              })
            ) : (
              <span className="text-muted">N/A</span>
            )}
          </div>
        );
      },

      sorter: (a, b) => {
        const aNames = a.staff_names
          ? String(a.staff_names).split(",").filter(Boolean).length
          : 0;

        const bNames = b.staff_names
          ? String(b.staff_names).split(",").filter(Boolean).length
          : 0;

        return aNames - bNames;
      },
    },

    {
      title: "Priority",
      dataIndex: "priority_name",

      sorter: (a, b) =>
        String(a.priority_name || "").localeCompare(
          String(b.priority_name || ""),
        ),

      render: (priorityName, record) => {
        const currentPriorityId = record.priority
          ? Number(record.priority)
          : undefined;

        const isRowUpdating = updatingPriorityTaskId === record.id;

        const getColor = (priority) => {
          switch (
            String(priority || "")
              .toLowerCase()
              .replace(/\s+/g, "")
          ) {
            case "low":
              return "#198754"; // green

            case "medium":
              return "#ffc107"; // yellow

            case "high":
              return "#fd7e14"; // orange

            case "urgent":
              return "#dc3545"; // red

            default:
              return "#6c757d"; // gray
          }
        };

        const selectedPriority = priorityOptions.find(
          (item) => Number(item.priorityid) === Number(currentPriorityId),
        );

        const priorityColor = getColor(selectedPriority?.name || priorityName);

        return (
          <Select
            value={selectedPriority ? currentPriorityId : undefined}
            size="small"
            loading={priorityOptionsLoading || isRowUpdating}
            disabled={isRowUpdating || priorityOptionsLoading}
            style={{
              width: 95,
            }}
            styles={{
              selector: {
                border: `1px solid ${priorityColor}`,
                borderRadius: "6px",
              },
            }}
            dropdownStyle={{
              zIndex: 9999,
            }}
            options={priorityOptions.map((option) => ({
              value: option.priorityid,
              label: option.name,
            }))}
            onChange={(newPriorityId) => {
              if (Number(newPriorityId) === Number(currentPriorityId)) {
                return;
              }

              updateTaskPriority(record.id, newPriorityId);
            }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: "9px",
                  }}
                />

                <span>{option.data.label}</span>
              </div>
            )}
            labelRender={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: priorityColor,
                    fontSize: "9px",
                  }}
                />

                <span>
                  {selectedPriority?.name || priorityName || "Select priority"}
                </span>
              </div>
            )}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          {/* <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("view", record);
                }}
              >
                <Eye className="info-img" />
                View
              </Link>
            </li>

            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("edit", record);
                  console.log(record, "recorddddddddddd");
                }}
              >
                <Edit className="info-img text-info" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                to="#"
                className="me-2 p-2 shadow-sm"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("edit", record);
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const [tasks, setTasks] = useState([]);
  const [taskloading, setTaskLoading] = useState(false);
  const [openAddTask, setOpenAddTask] = useState(false);

  const getTasks = async (Id) => {
    try {
      setTaskLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}tasks/GetTasksnew?projectid=${Id}`,
      );

      if (response.data.Status) {
        setTasks(response.data.ResultData || []);
      } else {
        setTasks([]);
      }
    } catch (error) {
      console.error("Get Tasks Error:", error);
      setTasks([]);
    } finally {
      setTaskLoading(false);
    }
  };

  const updateTaskStatus = async (taskId, statusId) => {
    try {
      setUpdatingStatusTaskId(taskId);

      const response = await fetch(`${BASE_CRM_URL}tasks/UpdateTaskStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: taskId,
          status: statusId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      if (result?.Status === false) {
        throw new Error(result?.Message || "Failed to update status");
      }

      message.success("Task status updated successfully");

      await Promise.all([getTasks(customerId)]);
    } catch (error) {
      console.error("Error updating task status:", error);

      message.error("Failed to update task status");
    } finally {
      setUpdatingStatusTaskId(null);
    }
  };

  const updateTaskPriority = async (taskId, priorityId) => {
    try {
      setUpdatingPriorityTaskId(taskId);

      const response = await fetch(`${BASE_CRM_URL}tasks/UpdateTaskPriority`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: taskId,
          priority: priorityId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      if (result?.Status === false) {
        throw new Error(result?.Message || "Failed to update priority");
      }

      message.success("Task priority updated successfully");

      await getTasks(customerId);
    } catch (error) {
      console.error("Error updating task priority:", error);

      message.error("Failed to update task priority");
    } finally {
      setUpdatingPriorityTaskId(null);
    }
  };

  useEffect(() => {
    if (customerId) {
      getTasks(customerId);
    }
  }, [customerId]);

  useEffect(() => {
    fetchTaskStatuses();
    fetchPriorities();
  }, []);

  const [detailDrawer, setDetailDrawer] = useState({
    open: false,
    mode: "view",
    taskId: null,
  });

  const openTaskDetail = (mode, record) => {
    setDetailDrawer({ open: true, mode, taskId: record?.id });
  };
  const closeTaskDetail = () => {
    setDetailDrawer((prev) => ({ ...prev, open: false }));
  };
  const handleEditTaskSuccess = async () => {
    setDetailDrawer((prev) => ({ ...prev, open: false }));
    await Promise.all([getTasks(customerId)]);
    message.success("Task updated successfully");
  };

  const [taskStatusCounts, setTaskStatusCounts] = useState([]);

  const fetchTaskStatusCounts = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}project/GetProjectTaskCounts?projectid=${customerId}`,
      );

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      if (result?.Status) {
        setTaskStatusCounts(result.ResultData || []);
      } else {
        setTaskStatusCounts([]);
      }
    } catch (error) {
      console.error("Error fetching task status counts:", error);
      setTaskStatusCounts([]);
    }
  };
  useEffect(() => {
    if (customerId) {
      fetchTaskStatusCounts();
    }
  }, [customerId]);

  const getTaskStatusCount = (statusId) => {
    const status = taskStatusCounts.find(
      (item) => Number(item.Id) === Number(statusId),
    );

    return Number(status?.StatusCount) || 0;
  };

  const getTotalTaskCount = () => {
    return Number(taskStatusCounts[0]?.TotalCount) || 0;
  };

  const [searchText, setSearchText] = useState("");

  const filteredData = tasks.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchText.toLowerCase()),
    ),
  );

  return (
    <>
      <div>
        <div className="row g-3">
          {/* Not Started */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill  shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h6 className="mb-0 fw-bold">
                    {getTaskStatusCount(1)}/{getTotalTaskCount()} Not Started
                  </h6>
                </div>

                <div
                  className="rounded-circle bg-secondary bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-list-check text-secondary fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* In Progress */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill  shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h6 className="mb-0 fw-bold">
                    {getTaskStatusCount(2)}/{getTotalTaskCount()} In-Progress
                  </h6>
                </div>

                <div
                  className="rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-spinner text-primary fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Testing */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h6 className="mb-0 fw-bold">
                    {getTaskStatusCount(3)}/{getTotalTaskCount()} Testing
                  </h6>
                </div>

                <div
                  className="rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-flask text-warning fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Awaiting Feedback */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h6 className="mb-0 fw-bold">
                    {getTaskStatusCount(4)}/{getTotalTaskCount()} Feedback
                  </h6>
                </div>

                <div
                  className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-message text-info fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Completed */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h6 className="mb-0 fw-bold">
                    {getTaskStatusCount(5)}/{getTotalTaskCount()} Completed
                  </h6>
                </div>

                <div
                  className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-circle-check text-success fs-4"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-3 d-none">
          <label className="form-label fw-semibold">Related To :</label>

          <div className="d-flex align-items-center flex-wrap gap-3 mt-2">
            <Checkbox checked disabled>
              Customer
            </Checkbox>

            <Checkbox>Projects</Checkbox>
            <Checkbox>Invoices</Checkbox>
            <Checkbox>Estimates</Checkbox>
            <Checkbox>Contracts</Checkbox>
            <Checkbox>Tickets</Checkbox>
            <Checkbox>Expenses</Checkbox>
            <Checkbox>Proposals</Checkbox>
          </div>
        </div>
        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            {/* <div className="search-set"> */}
            <Search
              placeholder="Search..."
              allowClear
              size="large"
              style={{ width: 300 }}
              onChange={(e) => setSearchText(e.target.value)}
            />
            {/* </div> */}
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="me-3 d-none">
                <Select
                  // defaultValue="Filter"
                  style={{ width: 180, height: 34 }}
                  // prefix={<FilterOutlined />}
                  placeholder="Choose Filter..."
                  options={[
                    { value: "Filter", label: "Filter" },
                    { value: "New Filter", label: "New Filter" },
                    { value: "Working", label: "Working" },
                    { value: "Assigned To Ajith", label: "Assigned To Ajith" },
                  ]}
                />
              </div>

              <div className="page-btn">
                <Link
                  to="#"
                  className="btn btn-success btn-sm me-2"
                  onClick={() => setOpenAddTask(true)}
                >
                  <i className="ti ti-circle-plus fs-4 "> </i>
                </Link>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className=" table-responsive">
              {taskloading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={filteredData} />
              )}
            </div>
          </div>
        </div>
        <NewTask
          open={openAddTask}
          onClose={() => setOpenAddTask(false)}
          type="project"
          id={customerId}
          onSuccess={async () => {
            setOpenAddTask(false);

            await getTasks(customerId);
          }}
        />

        <TaskDetailDrawer
          mode={detailDrawer.mode}
          taskId={detailDrawer.taskId}
          open={detailDrawer.open}
          onClose={closeTaskDetail}
          onSuccess={handleEditTaskSuccess}
          type="project"
          id={customerId}
        />

        <CommonFooter />
      </div>
    </>
  );
};

ProjectTasks.propTypes = {
  CustomerData: PropTypes.object,
};

export default ProjectTasks;
